import React from "react";
import { useTranslation } from "react-i18next";

import IconButton from "../IconButton";
import { MoveRightIcon, MoveRightLastPageIcon } from "../SVGs";
import {
  PAGINATION_LABEL_FALLBACKS,
  PAGINTAION_DEFAULT_PAGE,
} from "./Pagination.constants";
import PaginationPageNumberRenders from "./PaginationNumbers";

const PaginationButton = ({
  id,
  onClick,
  disabled,
  icon: Icon,
  flip,
  tooltip,
}) => (
  <IconButton id={id} onClick={onClick} disabled={disabled} tooltip={tooltip}>
    <Icon disabled={disabled} className={flip ? "flip-icon" : ""} />
  </IconButton>
);

const PaginationControls = ({ currentPage, totalPages, handlePageChange }) => {
  const { t } = useTranslation();

  const paginationLabel = {
    tooltipGoToLast:
      t("navigationLabels.goToLast") ||
      PAGINATION_LABEL_FALLBACKS.tooltipGoToLast,
    tooltipNext:
      t("navigationLabels.next") || PAGINATION_LABEL_FALLBACKS.tooltipNext,
    tooltipPrevious:
      t("navigationLabels.previous") ||
      PAGINATION_LABEL_FALLBACKS.tooltipPrevious,
    tooltipGoToFirst:
      t("navigationLabels.goToFirst") ||
      PAGINATION_LABEL_FALLBACKS.tooltipGoToFirst,
  };

  const isFirstPage = currentPage === PAGINTAION_DEFAULT_PAGE;
  const isLastPage = currentPage === totalPages;

  /**
   * Handles pagination button clicks by determining the target page based on the action
   * ('first', 'prev', 'next', 'last') and invoking the page change handler.
   */
  const handlePaginationButtonClick = (event) => {
    const action = event.target.id;
    const actionsMap = {
      "first-page": 1,
      "previous-page": currentPage - 1,
      "next-page": currentPage + 1,
      "last-page": totalPages,
    };

    const targetPage = actionsMap[action];
    if (targetPage !== undefined) {
      handlePageChange(targetPage);
    }
  };

  return (
    <div className="pagination-controls">
      <PaginationButton
        id="first-page"
        onClick={handlePaginationButtonClick}
        disabled={isFirstPage}
        icon={MoveRightLastPageIcon}
        flip
        tooltip={paginationLabel.tooltipGoToFirst}
      />
      <PaginationButton
        id="previous-page"
        onClick={handlePaginationButtonClick}
        disabled={isFirstPage}
        icon={MoveRightIcon}
        flip
        tooltip={paginationLabel.tooltipPrevious}
      />
      <PaginationPageNumberRenders
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      <PaginationButton
        id="next-page"
        onClick={handlePaginationButtonClick}
        disabled={isLastPage}
        icon={MoveRightIcon}
        tooltip={paginationLabel.tooltipNext}
      />
      <PaginationButton
        id="last-page"
        onClick={handlePaginationButtonClick}
        disabled={isLastPage}
        icon={MoveRightLastPageIcon}
        tooltip={paginationLabel.tooltipGoToLast}
      />
    </div>
  );
};

export default PaginationControls;
